function updateFill($range, instance, position) {
	var min = parseFloat($range.attr('min'));
	var max = parseFloat($range.attr('max'));
	var value = parseFloat($range.val());

	if (isNaN(min) || isNaN(max) || max === min) return;

	// where 0 sits on the track in %
	var zeroPos = ((0 - min) / (max - min)) * 100;

	// if plugin didn’t pass `position`, compute it
	if (typeof position !== 'number' || isNaN(position)) {
		position = ((value - min) / (max - min)) * 100;
	}

	// clamp to 0..100
	position = Math.max(0, Math.min(100, position));
	zeroPos = Math.max(0, Math.min(100, zeroPos));

	// get the fill element
	var $fill = (instance && instance.$fill && instance.$fill.length)
		? instance.$fill
		: $range.siblings('.rangeslider').find('.rangeslider__fill');

	if (!$fill || !$fill.length) return;

	var left, width;

	if (position >= zeroPos) {
		left = zeroPos;
		width = position - zeroPos;
	} else {
		left = position;
		width = zeroPos - position;
	}

	// clamp again for safety
	left = Math.max(0, Math.min(100, left));
	width = Math.max(0, Math.min(100 - left, width));

	$fill.css({
		left: left.toFixed(4) + '%',
		width: width.toFixed(4) + '%'
	});
}

$(document).ready(function () {
	$('input[type="range"]').rangeslider({
		polyfill: false
	});
});


